export const LANDING_CONTACT_EMAIL = 'info@myplanly.be';
